module.exports = __webpack_public_path__ + "img/conecta_track_full.db9f880d.png";